import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/EnrollmentForm.module.scss';

const EnrollmentFormHeader = ({ page, maxPage }) => {
  return (
    <header className={styles.EnrollmentFormHeader}>
      <span>
        Step {page}/{maxPage}
      </span>
      <progress value={page} max={maxPage}>
        {page}/{maxPage}
      </progress>
    </header>
  );
};

EnrollmentFormHeader.propTypes = {
  page: PropTypes.number.isRequired,
  maxPage: PropTypes.number.isRequired,
};

export default EnrollmentFormHeader;
